"use client";
import store from "./store";
import { Provider } from "react-redux";
import { FC, JSX, ReactNode } from "react";

/** Wraps the application with the Redux Provider. */
const StoreProvider: FC<{ children: ReactNode }> = ({ children }): JSX.Element => {
  return <Provider store={store}>{children}</Provider>;
};

export default StoreProvider;
